import React, { FC, useState } from "react";
import { notification, Spin, Tooltip } from "antd";
import memberDetailsService from "@services/memberDetails.service";
import PushPin from "@assets/ic_round-push-pin.svg";
import PushPinColor from "@assets/ic_round-push-pin-colored.svg";
import "./pinUnpin.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const PinUnpin: FC<any> = ({
  marginRight,
  dataCardId,
  changeHandler,
  pinCardIds
}) => {
  const [showLoader, setShowLoader] = useState<any>(false);
  const unPin = pinCardIds.indexOf(dataCardId+"") > -1;
  
  const pinUnpindata = (e: any) => {
    e.stopPropagation();
    setShowLoader(true);
    memberDetailsService
      .pinUnPinDataCard(dataCardId, unPin ? "remove" : "add")
      .subscribe({
        next: (v) => {
          setShowLoader(false);
          if (v?.data?.status === "ERROR") {
            notification.error({
              message: v?.data.status ? v?.data?.status : "Error",
              description: v?.data?.data?.result,
              onClick: () => {},
            });
          } else {
            changeHandler(dataCardId, !unPin);
          }
        },
        error: (e) => {
          setShowLoader(false);
          console.log(e?.data?.data?.result);
        },
      });
  };

  return (
    <Spin spinning={showLoader} indicator={<HealthemSpinner/>}>
      <Tooltip
        title="Pin it to My Dashboard"
        placement="leftTop"
        overlayClassName="pinUnpin-tooltip"
      >
        <span style={{ marginRight: `${marginRight}` }} onClick={pinUnpindata}>
          <img src={unPin ? PushPinColor : PushPin} alt="push-pin" />
        </span>
      </Tooltip>
    </Spin>
  );
};

export default PinUnpin;
